import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ReactGA from "react-ga4";
import SHA from "sha.js";
import { useAuth } from "../../Context/AuthContext";
import {
  buf2hex,
  encryptText,
  pbdkf2,
  str2buf,
} from "../../Utils/OstreonEncryption";
import styles from "./styles/Register.module.css";
import config from "../../config";
import PasswordRequirements from "../Password Requirements/PasswordRequirements";
import { validatePasswordStrength } from "../../Utils/passwordRequirements";
import { CheckEmail } from "./CheckEmail";
import Info from "../User/Info/info";
import parse from "html-react-parser";
import { formatTime } from "../../Utils/formatTime";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { ReactComponent as ReferralSvg } from "./styles/img/referral.svg";
import dayjs from "dayjs";
import { formattingRedirectionUrl } from "../../Utils/redirectingUrl";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";
import useWindowDimensions from "../Footer/footer";

const base_url = config.base_url;
function RegisterWithRequiredPhone() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  const [disableButton, setDisableButton] = useState(false);
  useEffect(() => {
    scrollToTop();
  }, []);
  const devEnv =
    window?.location?.host.includes("localhost") ||
    window?.location?.host.includes("127.0.0") ||
    window?.location?.host.includes("preprod");
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.Register.Register
  );

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Register.Register);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [countryLabel, setCountryLabel] = useState(null);
  const [succes, setSuccess] = useState(false);
  const [checked, setChecked] = useState(false);
  const [coupon, setCoupon] = useState({});
  const urlParams = new URLSearchParams(window.location.search);
  // const referralCode = urlParams.get('referral')
  // const referralID = urlParams.get('id')
  const [idParams, setIdparams] = useState(urlParams.get("id"));
  const [referralParams, setReferralparams] = useState(
    urlParams.get("referral")
  );

  const [checkedSubscribe, setCheckedSubscribe] = useState(true);
  const [error, setError] = useState({
    email: null,
    name: null,
    phone_number: null,
    password: null,
    confirm_password: null,
    register_error: null,
    based_usa: null,
  });
  const [data, setData] = useState({
    email: sessionStorage.getItem("userEmail") || "",
    name: "",
    phone_number: "",
    password: "",
    confirm_password: "",
    based_usa: "",
  });
  const errorMessages = {
    email: dublicatedcontent.dublicatedText47,
    name: content.signupFirstNameError,
    phone_number: content.signupLastNameError,
    password: content.signupPasswordError,
    confirm_password: content.signupConfirmPasswordError,
    based_usa: content.signupBasedUSAError,
  };
  const [pwdreq, setpwdreq] = useState();
  const [pwdreqconfirm, setpwdreqConfirm] = useState();
  useEffect(() => {
    sessionStorage.removeItem("userEmail");
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu";
    document.body.appendChild(script);
  }, []);
  const resetError = () => {
    Object.keys(error).forEach((key) => {
      setError((prevError) => ({ ...prevError, [key]: null }));
    });
  };
  const validateData = () => {
    resetError();
    if (validateForm()) {
      return true;
    }
    setTimeout(() => {
      resetError();
    }, 5000);
    return false;
  };

  useEffect(() => {
    let referral_ = referralParams || window?.localStorage?.getItem("referral");
    console.log(referralParams);
    if (referral_) {
      fetch(base_url + "newuser/referral/validate", {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-type": "application/x-www-form-urlencoded",
          credentials: "include",
        },
        body: `coupon=${referral_}&dollar_quantity=1`,
        credentials: "include",
      })
        .then((res) => {
          if (res.status !== 200) throw new Error("Not vali coupon");
          else return res.json();
        })
        .then((res) => {
          console.log(res);
          setCoupon(res);
          setReferralparams(referral_);
        })
        .catch((e) => {
          setIdparams(undefined);
          setReferralparams(undefined);
        });
    } else {
      setIdparams(undefined);
      setReferralparams(undefined);
    }
  }, []);
  const validateForm = () => {
    let passValidated = false,
      fieldsValidated = false,
      emailValidated = false,
      passMatchValidated = false;

    if (Object.keys(pwdreq).some((key) => pwdreq[key] === "")) {
      setError({ ...error, password: content.signupPasswordError2 });
    } else {
      passValidated = true;
    }

    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(data["email"])) {
      setError((prevError) => ({
        ...prevError,
        email: dublicatedcontent.dublicatedText47,
      }));
    } else {
      emailValidated = true;
    }

    if (data["password"] !== data["confirm_password"]) {
      setError((prevError) => ({
        ...prevError,
        confirm_password: content.signupPasswordNotMatch,
      }));
    } else {
      passMatchValidated = true;
    }

    const emptyKeys = Object.keys(data)
      .filter((key) => key !== "phone_number" && data[key] === "")
      .map((key) => key);
    emptyKeys.forEach((key) => {
      if (data[key] === "") {
        setError((prevError) => ({ ...prevError, [key]: errorMessages[key] }));
      }
    });
    if (emptyKeys.length === 0) {
      fieldsValidated = true;
    }

    if (
      passValidated &&
      fieldsValidated &&
      emailValidated &&
      passMatchValidated
    ) {
      return true;
    }
  };
  const changeData = (value, field) => {
    setData((prevData) => ({ ...prevData, [field]: value }));
  };
  const trimField = (value, field) => {
    const name = value.trim();
    changeData(name, field);
  };
  const [nameIsFocused, setNameIsFocused] = useState(false);
  const handleNameFocusIn = () => {
    setNameIsFocused(true);
    setPhoneNumberIsFocused(false);
    setPasswordIsFocused(false);
    setConfirmPasswordIsFocused(false);
  };

  const handleNameFocusOut = () => {
    setNameIsFocused(false);
  };

  // last name popup
  const [phoneNumberIsFocused, setPhoneNumberIsFocused] = useState(false);
  const handleLastNameFocusIn = () => {
    setPhoneNumberIsFocused(true);
    setNameIsFocused(false);
    setPasswordIsFocused(false);
    setConfirmPasswordIsFocused(false);
  };

  const handleLastNameFocusOut = () => {
    setPhoneNumberIsFocused(false);
  };

  // ============================ Show error when user exist ===============================
  const showExistedUserError = () => {
    setError((prevError) => ({
      ...prevError,
      email: parse(content.signupUserExist.replaceAll("`", '"')),
    }));
  };
  // password hide/show

  const [passwordVisibility, setPasswordVisibility] = useState({});

  const handleTogglePassword = (fieldName) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };

  const isPasswordVisible = (fieldName) => {
    return passwordVisibility[fieldName];
  };

  // password popups

  const [passwordIsFocused, setPasswordIsFocused] = useState(false);

  const handleMouseEnterPassword = () => {
    setPasswordIsFocused(true);
  };

  const handleMouseLeavePassword = () => {
    setPasswordIsFocused(false);
  };

  const [hideTimeout, setHideTimeout] = useState(null);

  const handlePasswordFocusIn = () => {
    clearTimeout(hideTimeout); // Clear any existing timeout
    setPasswordIsFocused(true);
    setConfirmPasswordIsFocused(false);
  };

  const handlePasswordFocusOut = () => {
    // Set a delay before hiding the div
    const timeout = setTimeout(() => {
      setPasswordIsFocused(false);
    }, 300); // Adjust the delay time (in milliseconds) as needed
    setHideTimeout(timeout);
  };

  // password confirm popups

  const [confirmPasswordIsFocused, setConfirmPasswordIsFocused] =
    useState(false);

  const handleMouseEnterConfirmPassword = () => {
    setConfirmPasswordIsFocused(true);
  };

  const handleMouseLeaveConfirmPassword = () => {
    setConfirmPasswordIsFocused(false);
  };

  const [hideConfirmTimeout, setHideConfirmTimeout] = useState(null);

  const handleConfirmPasswordFocusIn = () => {
    clearTimeout(hideConfirmTimeout); // Clear any existing timeout
    setConfirmPasswordIsFocused(true);
    setPasswordIsFocused(false);
  };

  const handleConfirmPasswordFocusOut = () => {
    // Set a delay before hiding the div
    const timeout = setTimeout(() => {
      setConfirmPasswordIsFocused(false);
    }, 300); // Adjust the delay time (in milliseconds) as needed
    setHideConfirmTimeout(timeout);
  };

  const generateKey = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let uid = "";
    for (let i = 0; i < 32; i++) {
      uid += chars[Math.floor(Math.random() * chars.length)];
    }
    return uid.replace(/(.{4})/g, "$1-").slice(0, -1);
  };

  const getAuth = async (password) => {
    const password_pbdkf2 = await pbdkf2(password, "OSTREON", 100000, 32 * 8);
    const recovery_key = generateKey();
    const recovery_key_pbdkf2 = await pbdkf2(
      recovery_key,
      "OSTREON",
      100000,
      32 * 8
    );
    const key = `${password}:${password}:${password}:OSTREON`;
    const private_key = SHA("sha256").update(key).digest("hex");
    const private_key_recovery_key = await encryptText(
      recovery_key,
      private_key
    );
    const recovery_key_private_key = await encryptText(
      private_key,
      recovery_key
    );
    return {
      private_key,
      password_pbdkf2: password_pbdkf2[0],
      recovery_key_pbdkf2: recovery_key_pbdkf2[0],
      private_key_recovery_key,
      recovery_key_private_key,
    };
  };

  useEffect(() => {
    setpwdreq(validatePasswordStrength(data.password, true));
    setpwdreqConfirm(validatePasswordStrength(data.confirm_password));
  }, [data.password]);
  const submitCaptcha = () => {
    return new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu")
          .then((token) => {
            resolve(token);
          })
          .catch((error) => {
            reject(error);
          });
      });
    });
  };
  const handleClick = async () => {
    if (!validateData()) {
      console.log("Data is not correct. Please check it");
      return;
    }
    if (Object.keys(pwdreq).some((key) => pwdreq[key] === "")) {
      setError({ ...error, register_error: content.signupPasswordError2 });
      setTimeout(() => {
        setError({});
      }, 4000);
      return;
    }

    setDisableButton(true);
    const token = await submitCaptcha();
    const {
      private_key,
      password_pbdkf2,
      recovery_key_pbdkf2,
      private_key_recovery_key,
      recovery_key_private_key,
    } = await getAuth(data.password);
    const customer_name = encryptText(private_key, data.name);
    // const customer_last_name = encryptText(private_key, data.lastname);
    //Vamos a handlear el si está en USA o no
    let register_url = base_url;

    const location = data.based_usa === "yes" ? "us" : "eu";
    // if (data.based_usa === "yes") {
    //   register_url = "https://ostreon.io/api/";
    // } else if (data.based_usa === "no") {
    //   register_url = "https://eu.ostreon.io/api/";
    // }
    let body = `webinar=${true}&token=${token}&email=${data.email}&name=${
      data.name
    }&password=${password_pbdkf2}&recovery_key=${recovery_key_pbdkf2}&private_key_recovery_key=${private_key_recovery_key}&recovery_key_private_key=${recovery_key_private_key}&newsletter=${checkedSubscribe}&language=${
      websiteCurrentLang?.label
    }&referralId=${idParams}&referralCode=${referralParams}&location=${location}`;
    if (data.phone_number && data.phone_number?.length > 3) {
      body =
        body +
        `&phone_number=${data.phone_number
          .replaceAll(" ", "")
          .replaceAll("+", "")
          .trim()}`;
    }
    fetch(register_url + "newuser", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) return res.json();
        else throw new Error(res.status);
      })
      .then((data_) => {
        console.log(data_);
        if (data_.error) {
          console.log("Ha entrado");
          if (data_.error === "NotConfirmed") {
            setError({
              ...error,
              register_error: content.signupEmailConfirmCreationError,
            });
            setTimeout(() => {
              resetError();
            }, 5000);
          } else {
            setError({ ...error, register_error: data_.error });
            setTimeout(() => {
              resetError();
            }, 5000);
            return;
          }
        } else {
          // const redirect_url = `${register_url.replace('/api/', '')}/register/confirm/${data_?.redirect_id}`
          // window.location.replace(redirect_url)
          if (base_url === register_url) setSuccess(true);
          else {
            const redirect_url = `${register_url.replace(
              "/api/",
              ""
            )}/register/confirm/${data_?.redirect_id}`;
            window.location.replace(redirect_url);
          }
          ReactGA.event("sign_up");
          localStorage.setItem("redirection_page", "plan");
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.message === "409") showExistedUserError();
        else {
          setError({ ...error, register_error: content.signupGeneralError });
          setTimeout(() => {
            setError({ ...error, register_error: null });
          }, 5000);
        }
      })
      .finally(() => {
        setDisableButton(false);
      });
  };
  const checkPassRequirements = () => {
    setpwdreq(validatePasswordStrength(data.password, true));
  };
  const checkPassConfirmRequirements = () => {
    setpwdreq(validatePasswordStrength(data.password, true));
    setpwdreqConfirm(
      validatePasswordStrength(
        data.confirm_password,
        data["password"] === data["confirm_password"] &&
          data["confirm_password"] !== ""
      )
    );
  };
  useEffect(() => {
    checkPassRequirements();
  }, [data.password]);

  useEffect(() => {
    checkPassConfirmRequirements();
  }, [data.confirm_password]);
  const ReferralIsNotSuperCode = () => {
    return (
      <div className={styles.referral}>
        <ReferralSvg />
        <p
          style={{
            fontWeight: "700",
          }}
        >
          {dublicatedcontent.dublicatedText201}
        </p>
        <div
          className={styles.referralCode}
          style={
            !coupon.amount_off && !coupon.percent_off && !coupon.time
              ? { marginBottom: "3px" }
              : {}
          }
        >
          <p>{referralParams}</p>
        </div>
        {coupon.amount_off && (
          <div className={styles.referralCodeContainer}>
            <span>{dublicatedcontent.dublicatedText202}</span>

            <br />
            <span
              style={{
                color: "#0091EA",
                fontWeight: "700",
              }}
            >
              {dublicatedcontent.dublicatedText203}
              {coupon.amount_off_currencies["usd"]}
              &nbsp;{dublicatedcontent.dublicatedText204}
            </span>
            <br />
            <span
              style={{
                color: "#0091EA",
              }}
            >
              {dublicatedcontent.dublicatedText205}
            </span>
          </div>
        )}
        {coupon.percent_off && !coupon?.applies_to && (
          <div className={styles.referralCodeContainer}>
            <span>{dublicatedcontent.dublicatedText202}</span>

            <br />
            <span
              style={{
                color: "#0091EA",
                fontWeight: "700",
              }}
            >
              {dublicatedcontent.dublicatedText206} {coupon.percent_off}
              %&nbsp;{dublicatedcontent.dublicatedText207}
            </span>
            <br />
            <span
              style={{
                color: "#0091EA",
              }}
            >
              {dublicatedcontent.dublicatedText205}
            </span>
          </div>
        )}
        {coupon.percent_off && coupon?.applies_to && (
          <div className={styles.referralCodeContainer}>
            <span>
              {dublicatedcontent.for_a_subscription_of_a_plan?.replace(
                "plan_names",
                coupon?.applies_to
                  ?.map(
                    (product) =>
                      product?.metadata[
                        `${websiteCurrentLang?.label}_name`
                      ]?.toLowerCase() || product?.name?.toLowerCase()
                  )
                  .join(` ${dublicatedcontent.or} `)
              )}
            </span>

            <br />
            <span
              style={{
                color: "#0091EA",
                fontWeight: "700",
              }}
            >
              {dublicatedcontent.you_will_receive_discount_initial_price?.replace(
                "discount_percentage",
                `${coupon.percent_off}`
              )}
            </span>
            <br />
            <span
              style={{
                color: "#0091EA",
              }}
            >
              {dublicatedcontent.dublicatedText205}
            </span>
          </div>
        )}
        {coupon.time && (
          <div className={styles.referralCodeContainer}>
            <span>{dublicatedcontent.dublicatedText202}</span>
            <br />
            <span>
              {dublicatedcontent.you_will_receive}&nbsp;
              {/* {coupon.time} {dublicatedcontent.dublicatedText118} */}
              {formatTime(coupon?.time, dublicatedcontent, true)?.toLowerCase()}
              &nbsp;{dublicatedcontent.dublicatedText208}
            </span>
            <br />
            <span
              style={{
                color: "#0091EA",
                fontWeight: "700",
              }}
            >
              {dublicatedcontent.dublicatedText209}&nbsp;
              {dublicatedcontent?.price_format
                ?.replace("currency_", dublicatedcontent?.main_currency_symbol)
                ?.replace(
                  "amount_",
                  ((97 / 31536000000) * Math.round(coupon.time)).toFixed(0)
                )}
            </span>
            <br />

            <span
              style={{
                color: "#0091EA",
              }}
            >
              {dublicatedcontent.dublicatedText205}
            </span>
          </div>
        )}
      </div>
    );
  };
  const ReferralIsSuperCode = () => {
    return (
      <div className={styles.referral}>
        <ReferralSvg />
        <p
          style={{
            fontWeight: "700",
          }}
        >
          {dublicatedcontent.dublicatedText274}
        </p>
        <div
          className={styles.referralCode}
          style={
            !coupon.amount_off && !coupon.percent_off && !coupon.time
              ? { marginBottom: "3px" }
              : {}
          }
        >
          <p>{referralParams}</p>
        </div>
        {coupon.recurrent && !coupon.supercode && (
          <div className={styles.referralCodeContainer}>
            {dublicatedcontent.dublicatedText275}
            <p
              style={{
                color: "#0091EA",
                fontSize: "15px",
              }}
            >
              {dublicatedcontent.dublicatedText205}
            </p>
          </div>
        )}
        {!coupon.recurrent && !coupon.amount_off && !coupon.percent_off && (
          <div className={styles.referralCodeContainer}>
            {dublicatedcontent.dublicatedText276}
            <span style={{ fontWeight: "600 " }}>
              {websiteCurrentLang.label === "en"
                ? dayjs(coupon.subscription_end).format("YYYY-MM-DD")
                : dayjs(coupon.subscription_end).format("DD-MM-YYYY")}
            </span>
            <p
              style={{
                color: "#0091EA",
                fontSize: "15px",
              }}
            >
              {dublicatedcontent.dublicatedText205}
            </p>
          </div>
        )}
        {coupon.amount_off && (
          <div className={styles.referralCodeContainer}>
            {dublicatedcontent.dublicatedText277}
            {coupon.amount_off}
            {dublicatedcontent.dublicatedText278}
            <p
              style={{
                color: "#0091EA",
                fontSize: "15px",
              }}
            >
              {dublicatedcontent.dublicatedText205}
            </p>
          </div>
        )}
        {coupon.percent_off && (
          <div className={styles.referralCodeContainer}>
            {dublicatedcontent.dublicatedText279}
            <br />
            {coupon.percent_off}
            {dublicatedcontent.dublicatedText280}
            <p
              style={{
                color: "#0091EA",
                fontSize: "15px",
              }}
            >
              {dublicatedcontent.dublicatedText205}
            </p>
          </div>
        )}
      </div>
    );
  };
  return succes ? (
    <CheckEmail
      title={content.signupEmailError2}
      email_address={data.email}
      onBack={() => {
        const newData = {};
        console.log(newData);
        for (const key in data) {
          newData[key] = "";
        }
        setData(newData);
        setSuccess(false);
        setChecked(false);
      }}
    />
  ) : (
    <div className={styles.background}>
      <div
        className={styles.home_link}
        onClick={() => {
          window.location.href = formattingRedirectionUrl("");
        }}
      >
        {dublicatedcontent.dublicatedText41}
      </div>
      <div className={styles.title}>{content.signupTitle2}</div>
      <div className={styles.mainContainer}>
        {referralParams && !coupon.supercode && width <= 1200 && (
          <div className={styles.referral}>
            <ReferralSvg />
            <p
              style={{
                fontWeight: "700",
              }}
            >
              {dublicatedcontent.dublicatedText201}
            </p>
            <div className={styles.referralCode}>
              <p>{referralParams}</p>
            </div>
            {coupon.amount_off && (
              <div className={styles.referralCodeContainer}>
                <span>{dublicatedcontent.dublicatedText202}</span>

                <br />
                <span
                  style={{
                    color: "#0091EA",
                    fontWeight: "700",
                  }}
                >
                  {dublicatedcontent.dublicatedText203}
                  {coupon.amount_off_currencies["usd"]}
                  &nbsp;{dublicatedcontent.dublicatedText204}
                </span>
                <br />
                <span
                  style={{
                    color: "#0091EA",
                  }}
                >
                  {dublicatedcontent.dublicatedText205}
                </span>
              </div>
            )}
            {coupon.percent_off && !coupon?.applies_to && (
              <div className={styles.referralCodeContainer}>
                <span>{dublicatedcontent.dublicatedText202}</span>

                <br />
                <span
                  style={{
                    color: "#0091EA",
                    fontWeight: "700",
                  }}
                >
                  {dublicatedcontent.dublicatedText206} {coupon.percent_off}
                  %&nbsp;{dublicatedcontent.dublicatedText207}
                </span>
                <br />
                <span
                  style={{
                    color: "#0091EA",
                  }}
                >
                  {dublicatedcontent.dublicatedText205}
                </span>
              </div>
            )}
            {coupon.percent_off && coupon?.applies_to && (
              <div className={styles.referralCodeContainer}>
                <span>
                  {dublicatedcontent.for_a_subscription_of_a_plan?.replace(
                    "plan_names",
                    coupon?.applies_to
                      ?.map(
                        (product) =>
                          product?.metadata[
                            `${websiteCurrentLang?.label}_name`
                          ]?.toLowerCase() || product?.name?.toLowerCase()
                      )
                      .join(` ${dublicatedcontent.or} `)
                  )}
                </span>

                <br />
                <span
                  style={{
                    color: "#0091EA",
                    fontWeight: "700",
                  }}
                >
                  {dublicatedcontent.you_will_receive_discount_initial_price?.replace(
                    "discount_percentage",
                    `${coupon.percent_off}`
                  )}
                </span>
                <br />
                <span
                  style={{
                    color: "#0091EA",
                  }}
                >
                  {dublicatedcontent.dublicatedText205}
                </span>
              </div>
            )}
            {coupon.time && (
              <div className={styles.referralCodeContainer}>
                <span>{dublicatedcontent.dublicatedText202}</span>
                <br />
                <span>
                  {/* {dublicatedcontent?.you_will_receive} {coupon.time}{" "}
                  {dublicatedcontent.dublicatedText118}{" "} */}
                  {formatTime(coupon?.time, dublicatedcontent, true)?.toLowerCase()}
                  {" "}
                  {dublicatedcontent.dublicatedText208}
                </span>
                <br />
                <span
                  style={{
                    color: "#0091EA",
                    fontWeight: "700",
                  }}
                >
                  {dublicatedcontent.dublicatedText209}&nbsp;
                  {dublicatedcontent?.price_format
                    ?.replace(
                      "currency_",
                      dublicatedcontent?.main_currency_symbol
                    )
                    ?.replace(
                      "amount_",
                      ((97 / 31536000000) * Math.round(coupon.time)).toFixed(0)
                    )}
                </span>
                <br />
                <span
                  style={{
                    color: "#0091EA",
                  }}
                >
                  {dublicatedcontent.dublicatedText205}
                </span>
              </div>
            )}
          </div>
        )}
        {referralParams && coupon.supercode && width <= 1200 && (
          <ReferralIsSuperCode />
        )}
        <div className={styles.main}>
          {referralParams && !coupon.supercode && width > 1200 && (
            <ReferralIsNotSuperCode />
          )}
          {referralParams && coupon.supercode && width > 1200 && (
            <ReferralIsSuperCode />
          )}
          <div className={styles.inputs}>
            <div className={styles.input_div}>
              <div className={styles.input_title}>
                {dublicatedcontent.dublicatedText74}
              </div>
              <input
                placeholder={dublicatedcontent.dublicatedText74}
                onClick={() => setError({ ...error, email: null })}
                onChange={(e) =>
                  changeData(e.target.value.toLowerCase(), "email")
                }
                value={data.email}
                className={
                  error?.email ? styles.input_error : styles.input_input
                }
              ></input>
              {error?.email ? (
                <div className={styles.error_div}>
                  <div className={styles.error_logo}></div>
                  <div>{error?.email}</div>
                </div>
              ) : null}
            </div>
            <div className={styles.input_div}>
              <div className={styles.input_title}>
                {dublicatedcontent.dublicatedText268}
              </div>
              <input
                placeholder={dublicatedcontent.dublicatedText268}
                value={data.name}
                onClick={() => setError({ ...error, name: null })}
                onChange={(e) => changeData(e.target.value, "name")}
                onBlur={(e) => {
                  handleNameFocusOut();
                  trimField(e.target.value, "name");
                }}
                onFocus={() => handleNameFocusIn()}
                className={error.name ? styles.input_error : styles.input_input}
              ></input>
              {error.name ? (
                <div className={styles.error_div}>
                  <div className={styles.error_logo}></div>
                  <div>{error.name}</div>
                </div>
              ) : null}
              {nameIsFocused && (
                <div className={styles.name_hint}>
                  <div className={styles.hint_title}>
                    {" "}
                    {content.signupInput2Text1}
                  </div>
                  <div className={styles.hint_description}>
                    {content.signupInput2Text2}
                  </div>
                </div>
              )}
            </div>
            <div className={styles.input_div}>
              <div className={styles.not_required_input_title}>
                {dublicatedcontent.phone_number}
                <Info
                  message={dublicatedcontent.phone_number_info}
                  isBold={false}
                />
              </div>
              <PhoneInput
                inputClass="legalInput"
                countryCodeEditable={false}
                localization={
                  websiteCurrentLang?.label === "fr"
                    ? fr_phone_countries
                    : undefined
                }
                country={
                  countryLabel
                    ? countryLabel
                    : websiteCurrentLang?.label === "fr"
                    ? "fr"
                    : "us"
                }
                placeholder={dublicatedcontent.phone_number}
                value={data.phone_number}
                onClick={() => setError({ ...error, phone_number: null })}
                onChange={(e, country) => {
                  setCountryLabel(country.countryCode);
                  changeData(e, "phone_number");
                }}
                onBlur={(e) => {
                  handleLastNameFocusOut();
                  trimField(e.target.value, "phone_number");
                }}
                className={styles.input_input}
              />
            </div>
            <div className={styles.input_div}>
              <div className={styles.input_title}>
                {content.signupInput4}
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onMouseEnter={handleMouseEnterPassword}
                  onMouseLeave={(e) => {
                    setTimeout(() => {
                      handleMouseLeavePassword();
                    }, 1500);
                  }}
                >
                  <path
                    d="M5.85156 6.74961V5.39961C5.85156 3.16536 6.52656 1.34961 9.90156 1.34961C13.2766 1.34961 13.9516 3.16536 13.9516 5.39961V6.74961"
                    stroke="#26313D"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.2734 14.8505H6.52344C3.82344 14.8505 3.14844 14.1755 3.14844 11.4755V10.1255C3.14844 7.42549 3.82344 6.75049 6.52344 6.75049H13.2734C15.9734 6.75049 16.6484 7.42549 16.6484 10.1255V11.4755C16.6484 14.1755 15.9734 14.8505 13.2734 14.8505Z"
                    stroke="#26313D"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.5975 10.7999H12.6035"
                    stroke="#26313D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.89825 10.7999H9.90431"
                    stroke="#26313D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.19707 10.7999H7.20314"
                    stroke="#26313D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <input
                placeholder={content.signupInput4}
                onClick={() =>
                  setError({ ...error, password: null, confirm_password: null })
                }
                onChange={(e) => changeData(e.target.value, "password")}
                onFocus={() => handlePasswordFocusIn()}
                onBlur={(e) => {
                  handlePasswordFocusOut();
                }}
                type={isPasswordVisible("passwordField1") ? "text" : "password"}
                name="passwordField1"
                className={
                  error.password ? styles.input_error : styles.input_input
                }
              ></input>
              <div
                onClick={() => handleTogglePassword("passwordField1")}
                className={styles.password_button}
              >
                <svg
                  width="18"
                  height="15"
                  viewBox="0 0 18 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                    fill="#B3B3B3"
                  />
                  <path
                    d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                    fill="#B3B3B3"
                  />
                </svg>
              </div>
              {error.password ? (
                <div className={styles.error_div}>
                  <div className={styles.error_logo}></div>
                  <div>{error.password}</div>
                </div>
              ) : null}

              <div className={styles.password_popups}>
                {passwordIsFocused && <PasswordRequirements req={pwdreq} />}

                {passwordIsFocused && (
                  <div className={styles.pass_hint}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.85156 6.74961V5.39961C5.85156 3.16536 6.52656 1.34961 9.90156 1.34961C13.2766 1.34961 13.9516 3.16536 13.9516 5.39961V6.74961"
                        stroke="#26313D"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.2734 14.8505H6.52344C3.82344 14.8505 3.14844 14.1755 3.14844 11.4755V10.1255C3.14844 7.42549 3.82344 6.75049 6.52344 6.75049H13.2734C15.9734 6.75049 16.6484 7.42549 16.6484 10.1255V11.4755C16.6484 14.1755 15.9734 14.8505 13.2734 14.8505Z"
                        stroke="#26313D"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12.5975 10.7999H12.6035"
                        stroke="#26313D"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.89825 10.7999H9.90431"
                        stroke="#26313D"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.19707 10.7999H7.20314"
                        stroke="#26313D"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <div className={styles.pass_hint_text}>
                      <div className={styles.strong}>
                        {content.signupInput4Text1}
                      </div>
                      {content.signupInput4Text2}{" "}
                      {parse(content.signupInput4Text3)}
                      <div className={styles.red_text}>
                        {content.signupInput5Text4}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.input_div}>
              <div className={styles.input_title}>
                {content.signupInput5}
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onMouseEnter={() => handleMouseEnterConfirmPassword()}
                  onMouseLeave={(e) => {
                    setTimeout(() => {
                      handleMouseLeaveConfirmPassword();
                    }, 1500);
                  }}
                >
                  <path
                    d="M5.85156 6.74961V5.39961C5.85156 3.16536 6.52656 1.34961 9.90156 1.34961C13.2766 1.34961 13.9516 3.16536 13.9516 5.39961V6.74961"
                    stroke="#26313D"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.2734 14.8505H6.52344C3.82344 14.8505 3.14844 14.1755 3.14844 11.4755V10.1255C3.14844 7.42549 3.82344 6.75049 6.52344 6.75049H13.2734C15.9734 6.75049 16.6484 7.42549 16.6484 10.1255V11.4755C16.6484 14.1755 15.9734 14.8505 13.2734 14.8505Z"
                    stroke="#26313D"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.5975 10.7999H12.6035"
                    stroke="#26313D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.89825 10.7999H9.90431"
                    stroke="#26313D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.19707 10.7999H7.20314"
                    stroke="#26313D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <input
                placeholder={content.signupInput5}
                onClick={() =>
                  setError({ ...error, password: null, confirm_password: null })
                }
                type={isPasswordVisible("passwordField2") ? "text" : "password"}
                name="passwordField2"
                onFocus={() => handleConfirmPasswordFocusIn()}
                onBlur={(e) => {
                  handleConfirmPasswordFocusOut();
                }}
                onChange={(e) => changeData(e.target.value, "confirm_password")}
                className={
                  error.confirm_password
                    ? styles.input_error
                    : styles.input_input
                }
              ></input>
              <div
                onClick={() => handleTogglePassword("passwordField2")}
                className={styles.password_button}
              >
                <svg
                  width="18"
                  height="15"
                  viewBox="0 0 18 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                    fill="#B3B3B3"
                  />
                  <path
                    d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                    fill="#B3B3B3"
                  />
                </svg>
              </div>
              {error.confirm_password ? (
                <div type="password" className={styles.error_div}>
                  <div className={styles.error_logo}></div>
                  <div>{error.confirm_password}</div>
                </div>
              ) : null}

              <div className={styles.password_confirm_popups}>
                {confirmPasswordIsFocused && (
                  <PasswordRequirements req={pwdreqconfirm} />
                )}

                {confirmPasswordIsFocused && (
                  <div className={styles.confirm_pass_hint}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.85156 6.74961V5.39961C5.85156 3.16536 6.52656 1.34961 9.90156 1.34961C13.2766 1.34961 13.9516 3.16536 13.9516 5.39961V6.74961"
                        stroke="#26313D"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.2734 14.8505H6.52344C3.82344 14.8505 3.14844 14.1755 3.14844 11.4755V10.1255C3.14844 7.42549 3.82344 6.75049 6.52344 6.75049H13.2734C15.9734 6.75049 16.6484 7.42549 16.6484 10.1255V11.4755C16.6484 14.1755 15.9734 14.8505 13.2734 14.8505Z"
                        stroke="#26313D"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12.5975 10.7999H12.6035"
                        stroke="#26313D"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.89825 10.7999H9.90431"
                        stroke="#26313D"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.19707 10.7999H7.20314"
                        stroke="#26313D"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <div className={styles.pass_hint_text}>
                      <div className={styles.strong}>
                        {content.signupInput4Text1}
                      </div>
                      {content.signupInput4Text2}{" "}
                      {parse(content.signupInput4Text3)}
                      <div className={styles.red_text}>
                        {content.signupInput5Text4}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.input_div}>
              <div className={styles.input_title}>
                {content.signupInput6}
                <Info message={content.signupInput6Text1} />
              </div>
              <select
                onClick={() => setError({ ...error, based_usa: null })}
                onChange={(e) => changeData(e.target.value, "based_usa")}
                className={`${styles.select} ${
                  data.based_usa.length ? styles.select_filled : ""
                } ${error.based_usa ? styles.input_error : ""}`}
              >
                <option value="" hidden>
                  {content.signupInput6Text2}
                </option>
                <option value="yes">{content.signupInput6Text3}</option>
                <option value="no">{content.signupInput6Text4}</option>

                {devEnv && <option value="preprod">Preprod</option>}
              </select>
              {error.based_usa ? (
                <div className={styles.error_div}>
                  <div className={styles.error_logo}></div>
                  <div>{error.based_usa}</div>
                </div>
              ) : null}
            </div>
          </div>
          <div className={styles.footer}>
            <div className={styles.footer_upper}>
              <div
                onClick={(e) => {
                  setChecked(!checked);
                }}
                className={`${styles.checkbox} ${
                  checked ? styles.checked : styles.not_checked
                }`}
              />
              <div className={styles.tos}>
                {content.signupText1}{" "}
                <a
                  href="/terms-and-conditions"
                  target="_blank"
                  className={styles.bluetext}
                >
                  {dublicatedcontent?.terms_of_service}
                </a>
                ,{" "}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  className={styles.bluetext}
                >
                  {dublicatedcontent?.privacy_policy}
                </a>
              </div>
            </div>

            <div className={styles.footer_upper}>
              <div
                onClick={(e) => {
                  setCheckedSubscribe(!checkedSubscribe);
                }}
                className={`${styles.checkbox} ${
                  checkedSubscribe ? styles.checked : styles.not_checked
                }`}
              />
              <div className={styles.tos}>
                {dublicatedcontent?.subscribe_to_newsletter}
                <div className={styles.promo_text}>{content?.signupText4}</div>
              </div>
            </div>

            <div className={styles.buttons_div}>
              <button
                disabled={!checked || disableButton}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick();
                }}
                className={styles.bluebutton}
              >
                {content?.signupText5}
              </button>
            </div>
            <div className={styles.bottom}>
              <div className={styles.not_a_customer}>
                {content?.signupText6}
                <span
                  onClick={() => navigate("/login")}
                  className={styles.login_beneficiary}
                >
                  {content.signupText7}
                </span>
              </div>
            </div>
          </div>
          {error.register_error ? (
            <div type="password" className={styles.error_div}>
              <div className={styles.error_logo}></div>
              <div>{error.register_error}</div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
const generateKey = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let uid = "";
  for (let i = 0; i < 32; i++) {
    uid += chars[Math.floor(Math.random() * chars.length)];
  }
  return uid.replace(/(.{4})/g, "$1-").slice(0, -1);
};
export { RegisterWithRequiredPhone, generateKey };
